import { useCallback } from "react";
import { useAppDispatch, useAppSelector } from "../../store/root/hooks";
import { PhotoUploadPayload, PhotoUploadServiceOperators, ValidateTokenPayload, ValidateTokenServiceOperators } from "../../types/photoUpload";
import { photoUploadActions, selectPhotoUpload, selectValidateToken } from "../../store/photoUpload/slice";

const useValidateTokenService = (): Readonly<ValidateTokenServiceOperators> => {
  const dispatch = useAppDispatch();

  return {
    validateToken: useAppSelector(selectValidateToken),

    submitValidateToken: useCallback(
      (payload: ValidateTokenPayload) => {
        // Dispatch the start action to indicate that the API request is starting
        dispatch(photoUploadActions.validateToken(payload));

        try {
          // Assuming the API call is successful and returns a response
          dispatch(photoUploadActions.submitValidateTokenSuccess(payload));
        } catch (error) {
          dispatch(
            photoUploadActions.submitValidateTokenFailure("Something went wrong")
          )
        }
      },
      [dispatch]
    )
  };
};

const usePhotoUploadService = (): Readonly<PhotoUploadServiceOperators> => {
  const dispatch = useAppDispatch();

  return {
    photoUpload: useAppSelector(selectPhotoUpload),

    submitPhotoUpload: useCallback(
      (payload: PhotoUploadPayload) => {
        // Dispatch the start action to indicate that the API request is starting
        dispatch(photoUploadActions.submitPhotoUploadStart(payload));

        try {
          // Assuming the API call is successful and returns a response
          dispatch(photoUploadActions.submitPhotoUploadSuccess(payload));
        } catch (error) {
          dispatch(
            photoUploadActions.submitPhotoUploadFailure("Something went wrong")
          );
        }
      },
      [dispatch]
    )
  };
};

export  {useValidateTokenService,  usePhotoUploadService};
